import { render, staticRenderFns } from "./StepNav.vue?vue&type=template&id=0a08c39c&scoped=true&"
import script from "./StepNav.vue?vue&type=script&lang=js&"
export * from "./StepNav.vue?vue&type=script&lang=js&"
import style0 from "./StepNav.vue?vue&type=style&index=0&id=0a08c39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a08c39c",
  null
  
)

export default component.exports